<input *ngIf="role == 'Student'" type="hidden" id="security_decision_form" [value]="is_approved" />

<div id="customPopupSecurity2" class="modal">
  <div class="modal-content modal-content-30">
    <div class="modal-main-content">
      <button class="close delete-close" id="closeButtonSecurity2" tabindex="0"><img src="assets/images/close_circle.svg" alt="Close"></button>
      <h2 class="modal-heading center" tabindex="0">{{ KeyValue.security_popup_title }}</h2>
      <p class="modal-heading center">{{ KeyValue.navigation_decision_confirm }}</p>
      <div class="button-container button-container-center">
        <button class="modal-button yes-button" id="deleteButtonSecurity2">Confirm Save</button>
        <button class="modal-button delete-close" id="cancelButtonSecurity2">Don't Save</button>
      </div>
    </div>
  </div>
</div>

<div id="customPopupSecurity1" class="modal">
  <div class="modal-content modal-content-30">
    <div class="modal-main-content">
      <button class="close delete-close" id="closeButtonSecurity1"><img src="assets/images/close_circle.svg" alt="Close"></button>
      <h2 class="modal-heading center" tabindex="0">{{ KeyValue.error_popup_title }}</h2>
      <p class="modal-heading center" tabindex="0">{{ KeyValue.page_save_error }}</p>
      <div class="button-container button-container-center">
        <button class="modal-button delete-close" id="deleteButtonSecurity1">Ok</button>
      </div>
    </div>
  </div>
</div>

<div id="customPopupSecurity5" class="modal">
  <div class="modal-content modal-content-40">
    <div class="modal-main-content">
      <button class="close delete-close" id="closeButtonSecurity" aria-label="Close">
        <img src="assets/images/close_circle.svg" alt="Close">
      </button>
      <h2 class="modal-heading center" tabindex="0">{{ KeyValue.security_popup_title }}</h2>
      <p class="modal-heading center" tabindex="0">Are you sure you want to save your inputs?</p>
      <div class="button-container button-container-center">
        <button class="modal-button delete-close" id="cancelButtonSecurity">Cancel</button>
        <button class="modal-button yes-button" id="deleteButtonSecurity">Confirm Save</button>
      </div>
    </div>
  </div>
</div>

<div class="full-width">
  <div id="student-tab2" class="st-content active">
    <form #securityForm="ngForm" class="security_decision_form" (keydown.enter)="$event.preventDefault()"
      (ngSubmit)="submit()" novalidate>
      <h1 class="heading-level-2 blue-color mt-0">Purchase Securities</h1>
      <div class="security-input-content">
        <div class="security-input-form">
          <div class="security-group-container student">
            <div id="field-group-container">
            <div class="field-group"
              *ngFor="let purchase_security of securities.purchase_securities_attributes; let purchase_security_index = index">
              <div class="field-group" *ngIf="purchase_security.is_deleted === false">
                <div>
                  <span class="security-header" *ngIf="purchase_security_index === 0">
                    Security Type
                  </span>
                <div class="tooltip-pop right">
                  <select class="security-type" required
                    [(ngModel)]="securities.purchase_securities_attributes[purchase_security_index].security_type_dd_id "
                    id="security_type_dd_id{{ purchase_security_index }}"
                    name="security_type_dd_id{{purchase_security_index}}"
                    (change)="validate_with_security_type(security_type(purchase_security.security_type_dd_id), purchase_security_index)"
                    [ngClass]="setFieldColor(securities.purchase_securities_attributes[purchase_security_index].security_type_dd_id, saved_copy.purchase_securities_attributes[purchase_security_index].security_type_dd_id)"
                    [attr.aria-describedby]="'tooltipText' + purchase_security_index"
                    [attr.aria-label]="'Security Type'">
                    <option value=""
                      [attr.selected]="securities.purchase_securities_attributes[purchase_security_index].security_type_dd_id == '' ? 'selected' : null">
                      Select Security Type
                    </option>
                    <option *ngFor="let security_type of security_type_dd | keyvalue; let security_type_index = index"
                      [value]="security_type.value.id">
                      {{ security_type.value.name }}
                    </option>
                  </select>
                  <div class="tooltiptext security-tooltip" role="" [id]="'tooltipText' + purchase_security_index">
                    There are six types of securities that may be
                    purchased and sold: bills and bonds issued by the U.S.
                    Treasury; bonds issued by agencies; bonds issued by
                    state and local governments which are tax-exempt, and
                    interest rate swaps (fixed and Variable). Securities
                    are purchased and sold in $millions of par (maturity)
                    value. Fractional values such as $2.5 million are not
                    acceptable.
                  </div>
                </div>
                </div>

                <div>
                  <span class="security-header" *ngIf="purchase_security_index === 0">
                    Amount
                  </span>
                <div class="tooltip-pop right relative">
                  <input class="amount-field" 
                    type="text" placeholder="Amount"
                    [(ngModel)]="securities.purchase_securities_attributes[purchase_security_index].amount"
                    id="amount{{ purchase_security_index }}" name="amount{{purchase_security_index }}"
                    [ngClass]="[purchase_security_error[purchase_security_index]?.includes('amount') ? 'form_validation_error' : '', setFieldColor( securities.purchase_securities_attributes[ purchase_security_index ].amount, saved_copy.purchase_securities_attributes[ purchase_security_index ].amount)]"
                    maxlength="2"
                    data-max="{{security_validation[security_type(purchase_security.security_type_dd_id)]?.amount.max}}"
                    data-min="{{security_validation[security_type(purchase_security.security_type_dd_id)]?.amount.min}}"
                    (blur)="validate_security_fields($event, 'amount',1,99,purchase_security_index,security_type(purchase_security.security_type_dd_id))"
                    (keydown.enter)="validate_security_fields($event,'amount',1,99,purchase_security_index,security_type(purchase_security.security_type_dd_id))" 
                    [attr.aria-describedby]="'tooltipText+amount'"
                    [attr.aria-label]="'Amount'"/>
                  <div class="errortiptext error-full-width right" style="display: none" role="alert" tabindex="0"></div>
                  <div *ngIf="security_type(purchase_security.security_type_dd_id) != 'Tax Exempt'" class="tooltiptext security-tooltip" [id]="'tooltipText+amount'">
                    All securities are purchased and sold in millions of
                    par value amount (face value). The minimum transaction
                    is $1 million. The maximum amount of a single purchase
                    (or sale) order is $99 million.
                  </div>
                  <div *ngIf="security_type(purchase_security.security_type_dd_id) == 'Tax Exempt'" class="tooltiptext security-tooltip" [id]="'tooltipText+amount'">
                    All securities are purchased and sold in millions of
                    par value amount (face value). The minimum transaction
                    is $1 million. The maximum amount of a single purchase
                    (or sale) order is $5 million.
                  </div>
                </div>
                </div>

                <div>
                  <span class="security-header" *ngIf="purchase_security_index === 0">
                    <div>Maturity<br/><span style="font-weight: 400;">(Quarters)</span></div>
                  </span>
                <div class="tooltip-pop right relative">
                  <input class="maturity-field" type="text" placeholder="Maturity (Quarters)"
                    [(ngModel)]="securities.purchase_securities_attributes[purchase_security_index].maturity"
                    id="maturity{{ purchase_security_index }}" name="maturity{{ purchase_security_index }}"
                    [ngClass]="[purchase_security_error[purchase_security_index]?.includes('maturity') ? 'form_validation_error' : '',setFieldColor(securities.purchase_securities_attributes[purchase_security_index].maturity,saved_copy.purchase_securities_attributes[purchase_security_index].maturity)]"
                    maxlength="3"
                    data-max="{{security_validation[security_type(purchase_security.security_type_dd_id)]?.maturity.max}}"
                    data-min="{{security_validation[security_type(purchase_security.security_type_dd_id)]?.maturity.min}}"
                    (blur)="validate_security_fields($event,'maturity',1,120,purchase_security_index,security_type(purchase_security.security_type_dd_id))"
                    (keydown.enter)="validate_security_fields($event,'maturity',1,120,purchase_security_index,security_type(purchase_security.security_type_dd_id))" 
                    [attr.aria-describedby]="'tooltipText-maturity-' + purchase_security_index"
                    [attr.aria-label]="'Maturity'"/>
                  <div class="errortiptext error-full-width right widthOfError" style="display: none" role="alert" tabindex="0"></div>
                  <div class="tooltiptext" class="tooltiptext security-tooltip">
                    <table [id]="'tooltipText-maturity-' + purchase_security_index" role="tooltip" aria-live="polite">
                      <div class="sr-only">Maturity, (Quarters)</div>
                      <tr>
                        <th>Descriptions</th>
                        <th>Maturity Range</th>
                      </tr>
                      <tr>
                        <td>Treasury bills - zero coupon</td>
                        <td>1 - 4 quarters</td>
                      </tr>
                      <tr>
                        <td>Treasury bonds - interest bearing</td>
                        <td>1 - 120 quarters</td>
                      </tr>
                      <tr>
                        <td>Agency bonds securities</td>
                        <td>1 - 120 quarters</td>
                      </tr>
                      <tr>
                        <td>Municipals (bank-qualified)</td>
                        <td>specified on report B10</td>
                      </tr>
                      <tr>
                        <td>Fixed rate swap</td>
                        <td>2 - 80 quarters</td>
                      </tr>
                      <tr>
                        <td>Variable rate swap</td>
                        <td>2 - 80 quarters</td>
                      </tr>
                    </table>
                  </div>
                  </div>
                  <div id="fill_field_error{{ purchase_security_index }}"
                    [ngClass]="purchase_security_error[purchase_security_index]?.includes('amount') || purchase_security_error[purchase_security_index]?.includes('maturity') ? 'errortiptext error-full-width right' : 'no_error'">
                    Fill out row completely </div>
                  </div>
                  <div class="add-remove-buttons" *ngIf="isapproved()">
                    <div>
                      <div *ngIf="purchase_security_index === 0" class="remove-button-spacing">&nbsp;</div>
                    <button type="button" class="remove-field"
                      *ngIf="this.securities.purchase_securities_attributes.length > 1" href="javascript:void(0)"
                      style="display: inline;" (click)="deletePurchaseSecurity(purchase_security_index)" aria-label="Remove Purchase Security">-</button>
                  </div>
                  </div>
                </div>
              </div>
              <div class="add-remove-buttons" *ngIf="isapproved()">
                <button type="button"  class="add-field"
                  *ngIf="this.securities.purchase_securities_attributes.length < purchase_security_no"
                  href="javascript:void(0)" (click)="addNewPurchaseSecurity($event)" aria-label="Add New Purchase Security"><img src="assets/images/add.svg" role="none" alt=""></button>
              </div>
            </div>
          </div>
            <div class="tax-exempt-information">
              <p>Tax Exempt Bond Information</p>
              <ul>
                <li>$5 million available</li>
                <li>60 quarters maturity at {{ pur_security_info.quarters_maturity }}%</li>
                <li>Taxable-equivalent yield is {{ pur_security_info.taxEquivYield }}%</li>
              </ul>
            </div>
            <div class="tax-exempt-note">Note: Maximum bill maturity is 4 quarters. Commercial Paper Rate is {{ pur_security_info.commercial_paper_rate }}
              percent.</div>
          </div>

            <div class="security-input-table">
              <div class="security-table" tabindex="0" role="" aria-label="">
                <table>
                  <thead>
                    <tr>
                      <th scope="col">Maturity</th>
                      <th scope="col">Treasuries</th>
                      <th scope="col">Agency</th>
                      <th scope="col">Swaps</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let security_info of security_information">
                      <td>{{ security_info.maturity }}</td>
                      <td>{{ KeyValueService.round_value(2, security_info.treasuries) }}</td>
                      <td>{{ KeyValueService.round_value(2, security_info.agencies) }}</td>
                      <td>{{ KeyValueService.round_value(2, security_info.swaps) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
        </div>
        <div class="security-input-tabs">
          <h2 class="heading-level-2 blue-color mt-20">Sell Securities</h2>
            <div class="security-table security-table-newdesign">
              <table>
                <thead>
                  <tr>
                    <th>Security Number</th>
                    <th class="align-center">Par Value</th>
                    <th>Market Value</th>
                    <th>Book Value</th>
                    <th>Maturity</th>
                    <th>Sale Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let cat of category; let catindex = index">
                    <tr><td class="pull-left" colspan="6" id="{{cat}}_aria"><strong>{{ cat }}</strong></td></tr>
                    <tr *ngIf="!actual_category(cat)">
                      <td>&nbsp;</td>
                      <td>0</td>
                      <td>0</td>
                      <td>0</td>
                      <td>0</td>
                      <td>
                        <input title="text" aria-label="text" type="text" class="form-control" value="0" [disabled]="true" />
                      </td>
                    </tr>
                    <tr
                        *ngFor="let sell_security of securities.sell_securities_attributes;let sell_security_index = index">
                        <ng-container *ngIf="sell_security.category == cat">
                          <td>{{ sell_security.number }}</td>
                          <td>{{ sell_security.par_value }}</td>
                          <td>{{KeyValueService.round_value(3,sell_security.market_value)}}</td>
                          <td>{{KeyValueService.round_value(3,sell_security.book_value)}}</td>
                          <td>{{ sell_security.maturity }}</td>
                          <td>
                            <div class="tooltip-pop">
                              <div *ngIf="sell_security.maturity != 0 && sell_security.category != 'Tax Exempt'">
                                <input 
                                  [attr.aria-label] = "cat+'  '+sell_security.number+' sale amount'"
                                  type="text" class="form-control"
                                  [(ngModel)]="securities.sell_securities_attributes[sell_security_index].sale_amount"
                                  id="sale_amount{{ sell_security_index }}" name="sale_amount{{ sell_security_index }}"
                                  [ngClass]="[sell_security_error[sell_security_index] ?.includes('sale_amount') ? 'form_validation_error' : '',setFieldColor(securities.sell_securities_attributes[sell_security_index].sale_amount,saved_copy.sell_securities_attributes[sell_security_index].sale_amount)]"
                                  maxlength="2" data-max="{{ sell_security.par_value }}" min="1"
                                  (blur)="validate_security_fields($event,'sale amount',1,10,null,sell_security.category)"
                                  (keydown.enter)="validate_security_fields($event,'sale amount',1,10,null,sell_security.category)" aria-describedby="sale_amount{{ sell_security_index }}"/>
                                <div class="errortiptext error-full-width" style="display: none" role="alert"></div>
                              </div>
                              <div
                                *ngIf="sell_security.maturity != 0 && (sell_security.category == 'Tax Exempt1' || sell_security.category == 'Tax Exempt')">
                                <input type="text" class="form-control"
                                  [attr.aria-label] = "cat+'  '+sell_security.number+' sale amount'"
                                  [(ngModel)]="securities.sell_securities_attributes[sell_security_index].sale_amount"
                                  id="sale_amount{{ sell_security_index }}" name="sale_amount{{ sell_security_index }}"
                                  [ngClass]="[sell_security_error[sell_security_index]?.includes('sale_amount')? 'form_validation_error': '',setFieldColor(securities.sell_securities_attributes[sell_security_index].sale_amount,saved_copy.sell_securities_attributes[sell_security_index].sale_amount)]"
                                  maxlength="2" data-max="{{ sell_security.par_value }}" min="1"
                                  (blur)="validate_security_fields($event,'sale amount',1,5,null,sell_security.category)"
                                  (keydown.enter)="validate_security_fields($event,'sale amount',1,5,null,sell_security.category)" aria-describedby="sale_amount{{ sell_security_index }}"/>
                                <div class="errortiptext error-full-width" style="display: none" role="alert"></div>
                              </div>
                              <div class="tooltiptext security-tooltip-right">
                                Enter the amount in $millions of par value (no
                                fractional values).
                                {{ sell_security.category }} should be in the range
                                of 1 to {{ sell_security.par_value }}, inclusive.
                              </div>
                            </div>
                            <div *ngIf="sell_security.maturity == 0">
                              <input type="text" 
                              [attr.aria-label] = "cat+'  '+sell_security.number+' sale amount'"
                              class="form-control" value="0" [disabled]="true" title="Sales Amout" aria-label="Sales Amout"/>
                            </div>
                          </td>
                        </ng-container>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
        </div>
        <div class="full-width clear pull-left"
          *ngIf="role == 'Student' || role == 'InstructorAdmin' || role == 'Admin'">
          <button type="submit" (click)="submit()" (keydown.enter)="submit()" class="modify-action-button button-style1 mr-20 mb-30 pull-right">Save Changes</button>
        </div>
        <div *ngIf="role == 'Instructor'" class="full-width clear pull-left">
            <button type="button" (click)="ReturnDecisionPage()"
            class="modify-action-button button-style1 mr-20 mb-30 pull-right">
            Go Back
            </button>
        </div>

    </form>
  </div>
</div>

<button id="diabledbtn" onclick="disable_inputs()" style="display: none"></button>
<a href="javascript:void(0)" style="display: none" id="decisions-set-popup"
  class="btn btn-primary comman_btn remove_margin_top" data-bs-toggle="modal" data-bs-target="#header_create_newpopup" aria-label="Header Popup"></a>